import React from "react";
import "./CategoryNav.css";

/**
 * CategoryNav - Navigation component for product categories
 * @param {Array} categories - List of categories with counts
 * @param {string} selectedCategory - Currently selected category ID
 * @param {Function} onSelectCategory - Callback when a category is selected
 */
const CategoryNav = ({ categories, selectedCategory, onSelectCategory }) => {
  return (
    <nav className="category-nav" role="tablist">
      <div className="category-nav__container">
        {/* All Products Tab */}
        <button
          className={`category-nav__item ${!selectedCategory ? "category-nav__item--active" : ""}`}
          onClick={() => onSelectCategory(null)}
          role="tab"
          aria-selected={!selectedCategory}
          aria-controls="all-products"
        >
          <span className="category-nav__name">All Products</span>
          <span className="category-nav__count">
            {categories.reduce((sum, cat) => sum + cat.count, 0)}
          </span>
        </button>

        {/* Category Tabs */}
        {categories.map((category) => (
          <button
            key={category.id}
            className={`category-nav__item ${selectedCategory === category.id ? "category-nav__item--active" : ""}`}
            onClick={() => onSelectCategory(category.id)}
            role="tab"
            aria-selected={selectedCategory === category.id}
            aria-controls={category.id}
          >
            <span className="category-nav__name">{category.name}</span>
            <span className="category-nav__count">{category.count}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default CategoryNav;
